import { PaymentType } from './payment.model';
import { IngredientGroup } from "./ingredient_group.model";
import { Product, IProduct, ProductBuilder } from "./product.model";
import { UUID } from 'angular2-uuid';


export class ICartItem {
  protected id: string = '';
  protected quantity: number = 0;
  protected ingredientGroups: IngredientGroup[] = [];
  protected price: number = 0;
  protected price_v2: number = 0;
  protected name: string = '';
  protected uuid: string = '';

  get Id() {
    return this.id;
  }

  get Quantity() {
    return this.quantity;
  }

  get IngredientGroups() {
    return this.ingredientGroups;
  }

  get Price() {
    return this.price;
  }

  get PriceV2() {
    return this.price_v2;
  }

  get Name() {
    return this.name;
  }

  get UUID() {
    return this.uuid;
  }

  set UUID(uuid: string) {
    this.uuid = uuid;
  }

  get TotalPrice() {
    let total = this.price;
    this.ingredientGroups.forEach((ingredientGroup: IngredientGroup) => {

      let selected = false;
      ingredientGroup.Ingredients.forEach((ingredient: any) => {
        if (ingredient.selected === true) {

          // one-off fee regardless chosen items
          if (ingredientGroup.Price > 0 && selected === false && ingredientGroup.ChoiceType === "multipleSelection") {
            total += ingredientGroup.Price;
            selected = true;

          } else { // sum up each selected ingredient price
            total += ingredient.price;
          }
        }
      });
    })

    return total * this.quantity * 1.00;
  }

  get TotalPriceV2() {
    let total = this.price_v2;
    this.ingredientGroups.forEach((ingredientGroup: IngredientGroup) => {

      let selected = false;
      ingredientGroup.Ingredients.forEach((ingredient: any) => {
        if (ingredient.selected === true) {

          // one-off fee regardless chosen items
          if (ingredientGroup.PriceV2 > 0 && selected === false && ingredientGroup.ChoiceType === "multipleSelection") {
            total += ingredientGroup.PriceV2;
            selected = true;

          } else { // sum up each selected ingredient price
            total += ingredient.price_v2;
          }
        }
      });
    })

    return total * this.quantity;
  }

  get AllIngredientNames() {
    let names: string[] = [];
    this.ingredientGroups?.forEach((ingredientGroup: IngredientGroup) => {
      ingredientGroup.Ingredients.forEach((ingredient: any) => {
        if (ingredient.selected === true)
        names.push(ingredient.name);
      })
    });

    return names;
  }
}


export class CartItem extends ICartItem {

  constructor(builder: CartItemBuilder) {
    super();
    this.quantity = builder.Quantity;
    this.ingredientGroups = builder.IngredientGroups;
    this.price = builder.Price;
    this.price_v2 = builder.PriceV2;
    this.id = builder.Id;
    this.name = builder.Name;
    this.uuid = builder.UUID;
  }



  setQuantity(quantity: number) {
    this.quantity = quantity;
    return this;
  }


}


export class CartItemBuilder extends ICartItem {

  get Quantity() {
    return this.quantity;
  }

  setId(id: string) {
    this.id = id;
    return this;
  }

  setQuantity(quantity: number) {
    this.quantity = quantity;
    return this;
  }

  setIngredientGroups(groups: IngredientGroup[]) {
    this.ingredientGroups = groups;
    return this;
  }

  setPrice(price: number) {
    this.price = price;
    return this;
  }

  setPriceV2(price: number) {
    this.price_v2 = price;
    return this;
  }

  setName(name: string) {
    this.name = name;
    return this;
  }

  setUUID(uuid: string) {
    this.uuid = uuid;
    return this;
  }


  build(): CartItem {
    return new CartItem(this);
  }
}


export class ICart {
  protected cartItems: CartItem[] = [];
  protected deliveryRate: number = 0;
  protected deliveryRateV2: number = 0;
  protected restaurantId: string = '';
  protected restaurantName: string = '';
  protected areaId: string = '';


  get CartItems() {
    return this.cartItems;
  }

  get DeliveryRate() {
    return this.deliveryRate;
  }

  get DeliveryRateV2() {
    return this.deliveryRateV2;
  }

  get TotalPrice() {
    let total = 0.00;
    this.cartItems?.forEach((item: CartItem) => {
      total += item.TotalPrice;
    })

    return total;
  }

  get TotalPriceV2() {
    let total = 0;
    this.cartItems?.forEach((item: CartItem) => {
      total += item.TotalPriceV2;
    })

    return total;
  }

  get RestaurantId() {
    return this.restaurantId;
  }

  get RestaurantName() {
    return this.restaurantName;
  }

  get AreaId() {
    return this.areaId;
  }

}

export class Cart extends ICart {

  constructor(builder: CartBuilder) {
    super();
    this.cartItems = builder.CartItems;
    this.deliveryRate = builder.DeliveryRate;
    this.deliveryRateV2 = builder.DeliveryRateV2;
    this.restaurantId = builder.RestaurantId;
    this.restaurantName = builder.RestaurantName;
    this.areaId = builder.AreaId;
  }


  addItem(item: CartItem) {
    item.UUID = UUID.UUID();
    this.cartItems.push(item);
  }

  removeItem(item: CartItem) {
    let newcartItems = this.cartItems.filter((o: CartItem) => o.UUID !== item.UUID) ;
    this.cartItems = newcartItems;
  }

  setRestaurantId(restaurantId: string) {
    this.restaurantId = restaurantId;
    return this;
  }

  setRestaurantName(restaurantName: string) {
    this.restaurantName = restaurantName;
    return this;
  }

  setDeliveryRate(deliveryRate: number) {
    this.deliveryRate = deliveryRate;
    return this;
  }

  setDeliveryRateV2(deliveryRate: number) {
    this.deliveryRateV2 = deliveryRate;
    return this;
  }

  setAreaId(areaId: string) {
    this.areaId = areaId;
    return this;
  }

  toJSON() {
    return {
      delivery_rate: this.DeliveryRate,
      delivery_rate_v2: this.DeliveryRateV2,
      restaurant_id: this.RestaurantId,
      restaurant_name: this.RestaurantName,
      area_id: this.AreaId,
      cart_items: this.CartItems.map((item: CartItem) => {
        return {
          quantity: item.Quantity,
          ingredient_groups: item?.IngredientGroups?.map((ingredientGroup: IngredientGroup) => {
            return {
              choice_type: ingredientGroup.ChoiceType,
              description: ingredientGroup.Description,
              id: ingredientGroup.Id,
              name: ingredientGroup.Name,
              price: ingredientGroup.Price,
              price_v2: ingredientGroup.PriceV2,
              restaurant_id: ingredientGroup.RestaurantId,
              ingredients: ingredientGroup.Ingredients.map((ingredient: any) => {
                return {
                  selected: ingredient.selected,
                  price: ingredient.price,
                  price_v2: ingredient.price_v2,
                  name: ingredient.name,
                  id: ingredient.id,
                }
              }),
            }
          }),
          price: item.Price,
          price_v2: item.PriceV2,
          id: item.Id,
          name: item.Name,
          uuid: item.UUID,
        }
      }),
    }
  }
}


export class CartBuilder extends ICart{
  constructor(){
      super();
  }

  setItems(items: CartItem[]) {
    this.cartItems = items;
    return this;
  }

  setRestaurantId(restaurantId: string) {
    this.restaurantId = restaurantId;
    return this;
  }

  setRestaurantName(restaurantName: string) {
    this.restaurantName = restaurantName;
    return this;
  }

  setDeliveryRate(deliveryRate: number) {
    this.deliveryRate = deliveryRate;
    return this;
  }

  setDeliveryRateV2(deliveryRate: number) {
    this.deliveryRateV2 = deliveryRate;
    return this;
  }

  setAreaId(areaId: string) {
    this.areaId = areaId;
    return this;
  }

  build(): Cart {
    return new Cart(this);
  }

  load(json: string|null): Cart {
    let _default = `
    {
      "delivery_rate": 0.00,
      "delivery_rate_v2": 0,
      "restaurant_id": "",
      "restaurant_name": "",
      "area_id": "",
      "cart_items": []
    }`;

    let jCart: any = '';

    try {
      jCart = JSON.parse(json || _default);
    } catch (e) {
      console.log(e);
      jCart = JSON.parse(_default);
    }

    return new CartBuilder()
      .setDeliveryRate(jCart.delivery_rate)
      .setDeliveryRateV2(jCart.delivery_rate_v2)
      .setRestaurantId(jCart.restaurant_id)
      .setRestaurantName(jCart.restaurant_name)
      .setAreaId(jCart.area_id)
      .setItems(jCart.cart_items?.map((item: any) => {
        return new CartItemBuilder()
          .setQuantity(item.quantity)
          .setPrice(item.price)
          .setPriceV2(item.price_v2)
          .setId(item.id)
          .setName(item.name)
          .setUUID(item.uuid)
          .setIngredientGroups(item.ingredient_groups?.map((group: any) => {
            return <IngredientGroup>{
              ChoiceType: group.choice_type,
              Description: group.description,
              Id: group.id,
              Name: group.name,
              Price: group.price,
              PriceV2: group.price_v2,
              Ingredients: group.ingredients?.map((ingredient: any) => {
                return {
                  selected: ingredient.selected,
                  price: ingredient.price,
                  price_v2: ingredient.price_v2,
                  name: ingredient.name,
                  id: ingredient.id,
                }
              }),
            }
          }))
          .build()

      }))
      .build();
  }


}
